import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface BreadCrumpItem {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-bread-crump',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './bread-crump.html',
  styleUrl: './bread-crump.scss',
})
export class BreadCrump {
  @Input() title: string = '';
  @Input() description?: string = '';
  @Input() items: BreadCrumpItem[] = [];
}
